import api from '@pray/shared/utils/api';

export async function updatePrayRadioDaily({
  artistId,
  dailySeriesId,
  dailyItemId,
  title,
  body,
  quote,
  reference,
  transcript,
  version,
  backgroundImageUrl,
  audioUrl,
  audioFileName,
  newArtistId,
}: {
  artistId: string;
  dailySeriesId: string;
  dailyItemId: string;
  title?: string | null;
  body?: string | null;
  quote?: string | null;
  reference?: string | null;
  transcript?: string | null;
  version?: string | null;
  backgroundImageUrl?: string | null;
  audioUrl?: string | null;
  audioFileName?: string | null;
  newArtistId?: string;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailySeriesId) throw Error('Daily Series ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}/pray-radio-content`;
  const payload: Record<string, string | null> = {};
  if (title !== undefined) payload.title = title;
  if (body !== undefined) payload.body = body;
  if (quote !== undefined) payload.quote = quote;
  if (reference !== undefined) payload.reference = reference;
  if (transcript !== undefined) payload.transcript = transcript;
  if (version !== undefined) payload.version = version;
  if (backgroundImageUrl !== undefined) payload.background_image_url = backgroundImageUrl;
  if (audioUrl !== undefined) payload.audio_url = audioUrl;
  if (audioFileName !== undefined) payload.audio_file_name = audioFileName;
  if (newArtistId !== undefined) payload.new_artist_id = newArtistId;

  const response = await api.executePutRequest(url, payload);

  return response.data;
}
